import React, {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CardComponent} from "../../../components";
import {SET_NEXT_PAGE, SET_SECTION_FLAG_ACTION} from "../../../redux/actions";

const HMDASummary = () => {
  const dispatch = useDispatch();
  const navigateNext = useCallback((state, edit, applicant) => dispatch(SET_NEXT_PAGE(state, edit, applicant)), [dispatch]);
  const setSectionFlag = useCallback((section, flag) => dispatch(SET_SECTION_FLAG_ACTION(section, flag)), [dispatch]);
  const applicants = useSelector( state => state.wizardStore.model.applicants);
  const currentApplicant = useSelector( state => state.wizardStore.meta.currentApplicant);
  const totalApplicants = useSelector( state => state.wizardStore.meta.totalApplicants);
  const applicantIndex = parseInt(currentApplicant.toString());
  const total = parseInt(totalApplicants.toString());
  const applicant = applicants[applicantIndex];

  const _continueHandler = () => {
    if (applicantIndex < total - 1) {
      navigateNext("hmda_ethnicity", false, applicantIndex + 1);
    } else {
      setSectionFlag("hmda", true);
      navigateNext("down_payment_selection", false, 0);
    }
  };

  const _editHandler = (state) => {
    navigateNext(state, true, applicantIndex);
  };

  return (
    <CardComponent title={`${applicant.firstName}'s HMDA Summary`}>
      <div className="flex flex-col items-start max-w-xl">
        {
          (applicant && applicant.declarations != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">{`${applicant.firstName}'s Ethnicity`}</span>
            <button className="cp-btn-review" onClick={() => _editHandler("hmda_ethnicity")}>
              Edit
            </button>
          </div>
        }
        {
          (applicant && applicant.declarations != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">{`${applicant.firstName}'s Gender`}</span>
            <button className="cp-btn-review" onClick={() => _editHandler("hmda_gender")}>
              Edit
            </button>
          </div>
        }
        {
          (applicant && applicant.declarations != null) &&
          <div className="flex items-center justify-between mb-3 w-full">
            <span className="cp-font-r14w300g800">{`${applicant.firstName}'s Race`}</span>
            <button className="cp-btn-review" onClick={() => _editHandler("hmda_race")}>
              Edit
            </button>
          </div>
        }
      </div>
      <div className="flex flex-col items-center max-w-xl">
        <button className="cp-btn-primary" onClick={() => _continueHandler()}>
          Continue
        </button>
      </div>
    </CardComponent>
  )
};

export default HMDASummary;
